import React from 'react'
import PropTypes from 'prop-types'

const CreateStyledText = ({ value, label }) => {
  if (!value) return null
  if (value !== 'string') {
    return (
      <div className="card">
        <div className="card-header">
          <div className="cui__utils__heading mb-0">
            <strong>{label}</strong>
          </div>
        </div>
        <div className="card-body">
          <div className="kit__utils__table">
            {value.map(val => (
              <>
                {val.label ? <strong>{val.label}</strong> : null}
                {val.text ? <p>{val.text}</p> : null}
              </>
            ))}
          </div>
        </div>
      </div>
    )
  }
  return <span className="ant-form-text">{value}</span>
}
CreateStyledText.propTypes = {
  value: PropTypes.any,
  label: PropTypes.any
}
CreateStyledText.defaultProps = {
  value: '',
  label: ''
}

export default CreateStyledText
